module.exports = __webpack_public_path__ + "img/9.75a53e38.svg";